import Dexie from 'dexie'

/**
 * La **base commune** d'avant #158 : une seule base pour toute la tablette, dont les tables de
 * tournée portaient une colonne `teamId` et se lisaient filtrées. Plus rien ne l'ouvre.
 */
export const RETIRED_DATA_DATABASE_NAME = 'ghp-terrain-data'

/**
 * Efface la base commune, **sans la lire**.
 *
 * ⚠️ **Effacée, et non reprise, parce qu'elle ne porte rien de réel** : aucun agent n'avait
 * utilisé l'app en service quand les bases par équipe sont arrivées (28/09/2026). Ce qu'elle
 * contient vient de tablettes de test — et une purge ne vaut que pour ce cas-là. Sur une tablette
 * qui aurait porté des saisies non transmises, ce geste les perdrait : une nouvelle base à
 * retirer se décide de nouveau, elle ne s'efface pas par analogie.
 *
 * ⚠️ **Ne lève jamais** : une base qu'on ne parvient pas à effacer ne doit pas empêcher la tablette
 * de démarrer. Elle reste au repos, sans lecteur, et le prochain démarrage réessaie.
 */
export function deleteRetiredDatabase(): Promise<void> {
  return Dexie.delete(RETIRED_DATA_DATABASE_NAME).catch((error: unknown) => {
    console.error(`[sync] « ${RETIRED_DATA_DATABASE_NAME} » n'a pas pu être effacée.`, error)
  })
}
